import React from 'react';
import PropTypes from 'prop-types';
import { ORDERS_QUEUES } from '@app/reducer/orders';
import Button from '@chama/ui-components/components/Button';
import { injectIntl, FormattedMessage } from 'react-intl';
import Spinner from '@chama/ui-components/components/Spinner';
import { withRouter } from 'react-router';
import OrdersPanelSection from '../OrderPanelSection';
import IncomingOrdersSection from '../IncomingOrdersSection';
import OngoingOrdersSection from '../OngoingOrdersSection';
import './index.css';

const OrderPanel = ({
  activeOrder,
  dealers,
  ordersFinalized,
  intl: { formatMessage },
  fetchMoreFinalizedTickets,
  dismissOrder,
  cancelDelivery,
  router,
  offset,
  setCurrentOrder,
  intl,
  userId,
  selectedOrderQueue,
}) => {
  if (!Object.keys(dealers).length) {
    return <Spinner>Carregando dealers</Spinner>;
  }

  return (
    <React.Fragment>
      <div>
        {selectedOrderQueue === ORDERS_QUEUES.INCOMING && <IncomingOrdersSection />}

        {selectedOrderQueue === ORDERS_QUEUES.BEING_DELIVERED && <OngoingOrdersSection />}

        {selectedOrderQueue === ORDERS_QUEUES.FINALIZED && (
          <React.Fragment>
            <OrdersPanelSection
              dismissOrder={dismissOrder}
              cancelDelivery={cancelDelivery}
              orders={ordersFinalized}
              router={router}
              activeOrder={activeOrder}
              dealers={dealers}
              sectionName={formatMessage({
                id: 'tickets_overview_finalised',
                defaultMessage: 'Finalized orders',
              })}
              emptyMessage={formatMessage({
                id: 'tickets_overview_finalised_empty_message',
                defaultMessage: 'There are no finalized orders',
              })}
              offset={offset}
              setCurrentOrder={setCurrentOrder}
              intl={intl}
              userId={userId}
            />
            {/* <div className="OrderPanel__show_more_btn_wrapper">
              <Button variant="secondary" onClick={fetchMoreFinalizedTickets}>
              <FormattedMessage id="general.show_more" defaultMessage="Show more" />
              </Button>
            </div> */}
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

OrderPanel.propTypes = {
  activeOrder: PropTypes.object,
  dealers: PropTypes.object.isRequired,
  ordersFinalized: PropTypes.array.isRequired,
  intl: PropTypes.object.isRequired,
  fetchMoreFinalizedTickets: PropTypes.func.isRequired,
  dismissOrder: PropTypes.func.isRequired,
  cancelDelivery: PropTypes.func.isRequired,
  setCurrentOrder: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  offset: PropTypes.number.isRequired,
  userId: PropTypes.string.isRequired,
};

OrderPanel.defaultProps = {
  activeOrder: {},
};

const intlComponent = injectIntl(OrderPanel);

export default withRouter(intlComponent);



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrderPanel/index.jsx